import React from 'react';
import DatePicker from 'material-ui/DatePicker';

/**
 * `DatePicker` can be implemented as a controlled input,
 * where `value` is handled by state in the parent component.
 */
export default class DateField extends React.Component {

    constructor(props) {
        super(props);

        var state = {
            value: props.value,
        };
        if (typeof props.value === "string" && props.value.indexOf("/")) {
            var parts1 = props.value.split("/");
            state.dateValue = new Date(2017, parts1[1], parts1[0]);
            state.value = state.dateValue.getTime();
        }
        if (typeof props.value === "string" && props.value.indexOf("-")) {
            var parts2 = props.value.split("-");
            state.dateValue = new Date(parts2[0], parts2[1], parts2[2]);
            state.value = state.dateValue.getTime();
        }
        else if (typeof props.value === "number" && props.value) {
            state.dateValue = new Date(props.value);
        }
        this.state = state;
    }

    handleChange = (event, date) => {
        const onDateChange = this.props.onDateChange || (() => {});
        this.setState({
            dateValue: date,
            value: date.getTime(),
        }, onDateChange(event, date.getTime()));
        
    };

    render() {
        return (
            <div className="DateField">
            <DatePicker
                name={this.props.name}
                floatingLabelText={this.props.hintText}                
                hintText={this.props.hintText}                
                value={this.state.dateValue}
                
                onChange={this.handleChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Form/DateField.jsx